<div class="page-content">
    <div class="container-fluid">
        <p>badge works!</p>
    </div>
</div>